import React from 'react';
import PropTypes from 'prop-types';

function IncompleteSessionIcon({ color, ...rest }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill={color || 'currentColor'} style={{ marginLeft: 2 }} {...rest}>
      <path d="M24,21.334H0V18.667H24v2.666ZM24,16H16.07V5.333H24V16ZM13.4,16H10.6V5.333h2.8V16ZM7.93,16H0V5.333H7.93V16ZM24,2.667H0V0H24V2.666Z" />
    </svg>
  );
}

IncompleteSessionIcon.propTypes = {
  color: PropTypes.string,
};

export default IncompleteSessionIcon;
